import futureImage from '../assets/portfolio/future_1.webp';
import superGaugeImage from '/assets/portfolio/supergauge/pf_supergauge.webp';
import superGaugeSG8Image from '/assets/portfolio/supergauge/SG8.webp';
import superGaugeHeroImage from '/assets/portfolio/supergauge/SG_iphone_1 1.webp';
import superGaugeImage2 from '/assets/portfolio/supergauge/SG_2.webp';
import superGaugeImage3 from '/assets/portfolio/supergauge/SG_block_2.webp';
import futureTherapyImage from '/assets/portfolio/futuretherapy/Feature_FT.webp';
import ft1Image from '/assets/portfolio/futuretherapy/ft1.webp';
import ft2Image from '/assets/portfolio/futuretherapy/ft2.webp';
import ft3Image from '/assets/portfolio/futuretherapy/ft3.webp';
import ft4Image from '/assets/portfolio/futuretherapy/ft4.webp';
import ft5Image from '/assets/portfolio/futuretherapy/ft5.webp';
import ft6Image from '/assets/portfolio/futuretherapy/ft6.webp';
import ft7Image from '/assets/portfolio/futuretherapy/ft7.webp';
import pfFutureImage from '/assets/portfolio/futuretherapy/pf_future.webp';
import goodGrapesImage from '/assets/portfolio/goodgrapes/Feature_GG.webp';
import goodGrapes1Image from '/assets/portfolio/goodgrapes/GG_1.webp';
import goodGrapes2Image from '/assets/portfolio/goodgrapes/GG_2.webp';
import goodGrapes3Image from '/assets/portfolio/goodgrapes/GG_3.webp';
import goodGrapes4Image from '/assets/portfolio/goodgrapes/GG_4.webp';
import matteoFeatureImage from '/assets/portfolio/matteo/Feature_Matteo.webp';
import matteo1Image from '/assets/portfolio/matteo/matteo1.webp';
import matteo2Image from '/assets/portfolio/matteo/matteo2.webp';
import matteo3Image from '/assets/portfolio/matteo/matteo3.webp';
import matteo4Image from '/assets/portfolio/matteo/matteo4.webp';
import matteo5Image from '/assets/portfolio/matteo/matteo5.webp';
import matteo6Image from '/assets/portfolio/matteo/matteo6.webp';
import matteo7Image from '/assets/portfolio/matteo/matteo7.webp';
import matteo8Image from '/assets/portfolio/matteo/matteo8.webp';
import matteo9Image from '/assets/portfolio/matteo/matteo9.webp';
import matteoPfImage from '/assets/portfolio/matteo/pf_matteo.webp';
import llamaFeatureImage from '/assets/portfolio/llama/Feature_Llama.webp';
import llamaHeroImage from '/assets/portfolio/llama/llama_hero.webp';
import llamaBlock1Image from '/assets/portfolio/llama/llama_block_1.webp';
import llamaBlock2Image from '/assets/portfolio/llama/llama_block_2.webp';
import llamaBlock3Image from '/assets/portfolio/llama/llama_block_3.webp';
import llamaBlock4Image from '/assets/portfolio/llama/llama_block_4.webp';
import llamaBlock5Image from '/assets/portfolio/llama/llama_block_5.webp';
import llamaBlock6Image from '/assets/portfolio/llama/llama_block_6.webp';
import llamaBlock7Image from '/assets/portfolio/llama/llama_block_7.webp';
import llamaBlock8Image from '/assets/portfolio/llama/llama_block_8.webp';
import llamaBlock9Image from '/assets/portfolio/llama/llama_block_9.webp';
import sonarisFeatureImage from '/assets/portfolio/sonaris/Feature_Sonaris.webp';
import sonarisPfImage from '/assets/portfolio/sonaris/pf_sonaris.webp';
import sonarisBlock1 from '/assets/portfolio/sonaris/sonaris_block_1.webp';
import sonarisBlock4 from '/assets/portfolio/sonaris/sonaris_block_4.webp';
import sonarisBlock5 from '/assets/portfolio/sonaris/sonaris_block_5.webp';
import sonarisBlock6 from '/assets/portfolio/sonaris/sonaris_block_6.webp';
import jumpChargeImage from '/assets/portfolio/jumpcharge/pf_jumpcharge.webp';
import jumpCharge1Image from '/assets/portfolio/jumpcharge/jc1.webp';
import jumpCharge2Image from '/assets/portfolio/jumpcharge/jc2.webp';
import jumpCharge3Image from '/assets/portfolio/jumpcharge/jc3.webp';
import jumpCharge4Image from '/assets/portfolio/jumpcharge/jc4.webp';
import jumpCharge5Image from '/assets/portfolio/jumpcharge/jc5.webp';

// Fizzy Juice project images
import fizzyJuiceImage from '../assets/portfolio/fizzyjuice/FJ1.webp';
import fizzyJuice1Image from '../assets/portfolio/fizzyjuice/FizzyJuice1.webp';
import fizzyJuice2Image from '../assets/portfolio/fizzyjuice/FizzyJuice2.webp';

// Placeholder images for new projects
import llamaImage from '../assets/portfolio/Matteo_1.webp';
import sonarisImage from '../assets/portfolio/Matteo_1.webp';
import goodgrapesImage from '../assets/portfolio/future_1.webp';

export const PROJECTS = [
  {
    slug: 'future-therapy',
    title: 'Future Therapy',
    subtitle: 'Curated product and shopping directory and catalogue',
    meta: [
      { label: 'Client', value: 'Future Therapy' },
      { label: 'Focus', value: 'UX, UI, Build' },
      { label: 'Deliverables', value: 'Branding, website' },
      { label: 'Status', value: 'Live' },
    ],
    intro:
      'Future Therapy is a curated online catalogue designed to make discovering and organising products effortless. The platform emphasises a clean, intuitive interface that encourages exploration while keeping the focus on beautifully presented products.\n\nUsers can browse thoughtfully selected items, save their favourites, and create personalised lists tailored to their own goals or aesthetic. The design prioritises minimalism, and fluid navigation, ensuring a seamless experience across devices.',
    externalLink: 'https://futuretherapy.co.uk/',
    blocks: [
      {
        type: 'image',
        src: ft1Image,
        alt: 'Future Therapy project preview',
      },
      {
        type: 'two-images',
        images: [
          {
            src: ft1Image,
            alt: 'Future Therapy interface 1'
          },
          {
            src: ft4Image,
            alt: 'Future Therapy interface 2'
          }
        ]
      },
      {
        type: 'image',
        src: ft5Image,
        alt: 'Future Therapy feature 1',
      },
      {
        type: 'text',
        title: 'Approach',
        body:
          'We created a flexible identity system and a web experience that spotlights their ventures and thinking, with an emphasis on readability and pace.',
      },
      {
        type: 'two-images',
        images: [
          {
            src: ft3Image,
            alt: 'Future Therapy detail 1'
          },
          {
            src: ft2Image,
            alt: 'Future Therapy detail 2'
          }
        ]
      },
      {
        type: 'two-images',
        images: [
          {
            src: ft6Image,
            alt: 'Future Therapy feature 2'
          },
          {
            src: ft7Image,
            alt: 'Future Therapy feature 3'
          }
        ]
      },
      {
        type: 'image',
        src: pfFutureImage,
        alt: 'Future Therapy portfolio showcase',
      },
    ],
  },
  {
    slug: 'matteo',
    title: 'Matteo',
    subtitle: 'Identity and web design for family-run Italian restaurant',
    heroBackgroundImage: matteo8Image,
    meta: [
      { label: 'Client', value: 'Matteo' },
      { label: 'Focus', value: 'Brand + web' },
      { label: 'Deliverables', value: 'Identity, website' },
      { label: 'Platform', value: 'Wordpress' },
      { label: 'Status', value: 'Live' },
    ],
    intro:
      'A warm, modern identity and site that balances family heritage with a contemporary dining experience.',
    blocks: [
      {
        type: 'image',
        src: matteo4Image,
        alt: 'Matteo project preview',
      },
      {
        type: 'two-images',
        images: [
          {
            src: matteo1Image,
            alt: 'Matteo restaurant interior 1'
          },
          {
            src: matteo2Image,
            alt: 'Matteo restaurant interior 2'
          }
        ]
      },
      {
        type: 'text',
        title: 'What we did',
        body:
          'Brand identity, typography and tone, art direction, and a website designed to convert bookings while staying true to the atmosphere of the restaurant.',
      },
      {
        type: 'image',
        src: matteo3Image,
        alt: 'Matteo restaurant dining area',
      },
      {
        type: 'two-images',
        images: [
          {
            src: matteo4Image,
            alt: 'Matteo restaurant detail 1'
          },
          {
            src: matteo5Image,
            alt: 'Matteo restaurant detail 2'
          }
        ]
      },
      {
        type: 'image',
        src: matteo6Image,
        alt: 'Matteo restaurant atmosphere',
      },
      {
        type: 'two-images',
        images: [
          {
            src: matteo7Image,
            alt: 'Matteo restaurant feature 1'
          },
          {
            src: matteo8Image,
            alt: 'Matteo restaurant feature 2'
          }
        ]
      },
      {
        type: 'image',
        src: matteo9Image,
        alt: 'Matteo restaurant final view',
      },
      {
        type: 'image',
        src: matteoPfImage,
        alt: 'Matteo portfolio showcase',
      },
    ],
  },
  {
    slug: 'supergauge',
    title: 'SuperGauge',
    subtitle: 'An employee engagement platform that puts people first',
    heroBackgroundImage: superGaugeHeroImage,
    meta: [
      { label: 'Client', value: 'SuperGauge' },
      { label: 'Focus', value: 'Product design + build' },
      { label: 'Deliverables', value: 'UX, UI, web' },
      { label: 'Status', value: 'Ongoing' },
    ],
    intro:
      'Working closely with an HR and employee wellbeing specialist, as well as end users and partners, we developed a bespoke platform for engaging employees; capturing anonymous feedback; and empowering them to make change within their organisation.\n\nThrough rapid prototyping, testing and feedback, we designed an accessible platform and defined a tone and brand identity which encourages trust and honesty.\n\nAfter engaging with stakeholders and presenting findings and our proposal, we got to work prototyping the platform so that we could test it quickly and react quickly to live feedback.\n\nThe end result was a platform that made a positive impact on organisations\' NPS score and improved recruitment workflows.',
    externalLink: 'https://www.supergauge.co.uk',
    blocks: [
      {
        type: 'image',
        src: superGaugeHeroImage,
        alt: 'SuperGauge project preview',
      },
      {
        type: 'two-images',
        images: [
          {
            src: superGaugeImage2,
            alt: 'SuperGauge interface 1'
          },
          {
            src: superGaugeImage3,
            alt: 'SuperGauge interface 2'
          }
        ]
      },
      {
        type: 'text',
        title: 'The work',
        body:
          'We shaped the product vision, defined the information architecture, designed the UI system, and delivered a responsive build that could scale with the platform.',
      },
      {
        type: 'image',
        src: superGaugeImage,
        alt: 'SuperGauge interface preview',
      },
    ],
  },
  {
    slug: 'llama',
    title: 'Llama',
    subtitle: 'Llama, a platform for supporting people living with musculoskeletal conditions.',
    meta: [
      { label: 'Client', value: 'Llama' },
      { label: 'Focus', value: 'Product design + UX + UI' },
      { label: 'Deliverables', value: 'UX, UI, prototype' },
      { label: 'Status', value: 'In development' },
    ],
    intro:
      'Llama is an online platform which acts as a unified source of information and support for people living with MSK conditions, employers and clinicians.\n\nThe project involved rapid-prototyping a platform that could quickly and demonstrably deliver value and impact for stakeholders.\n\nAfter researching, testing and defining core user journey, wireframes were developed along with hi-res mockups and ultimately a prototype for enhanced testing and feedback.',
    blocks: [
      {
        type: 'image',
        src: llamaBlock5Image,
        alt: 'Llama platform hero',
      },
      {
        type: 'two-images',
        images: [
          {
            src: llamaBlock1Image,
            alt: 'Llama interface detail 1'
          },
          {
            src: llamaBlock2Image,
            alt: 'Llama interface detail 2'
          }
        ]
      },
      {
        type: 'image',
        src: llamaBlock9Image,
        alt: 'Llama block 9',
      },
      {
        type: 'image',
        src: llamaBlock3Image,
        alt: 'Llama workflow 1',
      },
      {
        type: 'image',
        src: llamaBlock4Image,
        alt: 'Llama workflow 2',
      },
      {
        type: 'two-images',
        images: [
          {
            src: llamaBlock5Image,
            alt: 'Llama feature 1'
          },
          {
            src: llamaBlock6Image,
            alt: 'Llama interface 3'
          }
        ]
      },
      {
        type: 'image',
        src: llamaBlock7Image,
        alt: 'Llama block 7',
      },
      {
        type: 'image',
        src: llamaBlock8Image,
        alt: 'Llama block 8',
      },
    ],
  },
  {
    slug: 'sonaris',
    title: 'Sonaris',
    subtitle: 'Ambient sounds app for focus, relaxation and sleep',
    meta: [
      { label: 'Client', value: 'Sonaris Media' },
      { label: 'Focus', value: 'Wellbeing, Productivity' },
      { label: 'Deliverables', value: 'App, UI, Build' },
      { label: 'Status', value: 'Beta' },
    ],
    intro:
      'A lightweight background noise track is perfect for crafting soothing ambient sound environments that promote focus, relaxation, and restful sleep.\n\nWith gentle tones and subtle textures, it creates a calming atmosphere without being distracting, helping to drown out unwanted noise and ease the mind into a state of tranquility. Whether used for studying, meditating, or winding down at night, this minimalist soundscape provides a serene backdrop that supports mental clarity and emotional well-being.',
    externalLink: 'https://sonaris-9rnk.vercel.app/',
    blocks: [
      {
        type: 'image',
        src: sonarisBlock5,
        alt: 'Sonaris hero image',
      },
      {
        type: 'two-images',
        images: [
          {
            src: sonarisBlock5,
            alt: 'Sonaris interface 1'
          },
          {
            src: sonarisBlock6,
            alt: 'Sonaris interface 2'
          }
        ]
      },
      {
        type: 'image',
        src: sonarisBlock4,
        alt: 'Sonaris analytics dashboard',
      },
      {
        type: 'text',
        title: 'Data-driven design',
        body:
          'We transformed complex audio analytics into intuitive visualizations that help music professionals understand trends, engagement patterns, and revenue opportunities at a glance.',
      },
      {
        type: 'image',
        src: sonarisBlock1,
        alt: 'Sonaris real-time streaming metrics',
      },
      {
        type: 'text',
        title: 'Technical innovation',
        body:
          'Built a responsive system that handles millions of data points in real-time, presenting them through beautiful, interactive charts and graphs that update live as music streams.',
      },
    ],
  },
  {
    slug: 'fizzy-juice',
    title: 'Fizzy Juice',
    subtitle: 'An ethical jobs board for people who work in hospitality',
    meta: [
      { label: 'Client', value: 'Fizzy Juice' },
      { label: 'Focus', value: 'Web platform, UX/UI, Full-stack' },
      { label: 'Deliverables', value: 'Design system, Website, Backend' },
      { label: 'Status', value: 'Live' },
    ],
    externalLink: 'https://fizzyjuice.uk',
    intro:
      'A comprehensive web platform design and build from the ground up, handling everything from initial UX research and UI design through to full-stack development and deployment. The project required balancing aesthetic appeal with technical functionality, creating a clean, modern interface that prioritises user experience while maintaining robust backend architecture.\n\nAlso established was a complete design system—including typography, color palette, component library, and responsive layouts—ensuring consistency across all touchpoints and devices.',
    blocks: [
      {
        type: 'image',
        src: fizzyJuiceImage,
        alt: 'Fizzy Juice project preview',
      },
      {
        type: 'image',
        src: fizzyJuice1Image,
        alt: 'Fizzy Juice job board interface mockup',
      },
      {
        type: 'text',
        title: 'Full-stack approach',
        body:
          'From initial user research and wireframing to final deployment, this project encompassed the complete web development lifecycle. We focused on creating an intuitive job board experience that serves both employers and job seekers in the hospitality industry.',
      },
      {
        type: 'image',
        src: fizzyJuiceImage,
        alt: 'Fizzy Juice interface design',
      },
      {
        type: 'image',
        src: fizzyJuice2Image,
        alt: 'Fizzy Juice responsive flow',
      },
      {
        type: 'text',
        title: 'Design system',
        body:
          'Developed a comprehensive design system including typography, color palette, component library, and responsive layouts. This ensures consistency across all touchpoints and devices while maintaining scalability for future features.',
      },
    ],
  },
  {
    slug: 'good-grapes',
    title: 'Good Grapes',
    subtitle: 'Wine subscription and discovery service',
    meta: [
      { label: 'Client', value: 'Good Grapes Co' },
      { label: 'Focus', value: 'Ecommerce, UX, Identity' },
      { label: 'Deliverables', value: 'Web, mobile, branding' },
      { label: 'Status', value: 'Live' },
    ],
    intro:
      'A curated wine subscription service that connects wine enthusiasts with boutique vineyards through personalized recommendations and educational content.',
    blocks: [
      {
        type: 'image',
        src: goodGrapesImage,
        alt: 'Good Grapes hero image',
      },
      {
        type: 'image',
        src: goodGrapes1Image,
        alt: 'Good Grapes subscription interface',
      },
      {
        type: 'image',
        src: goodGrapes2Image,
        alt: 'Good Grapes wine discovery',
      },
      {
        type: 'image',
        src: goodGrapes3Image,
        alt: 'Good Grapes taste profile',
      },
      {
        type: 'image',
        src: goodGrapes4Image,
        alt: 'Good Grapes brand experience',
      },
      {
        type: 'text',
        title: 'Taste profile system',
        body:
          'Developed an innovative taste-matching algorithm that learns user preferences over time, creating highly personalized wine recommendations that surprise and delight customers.',
      },
      {
        type: 'image',
        src: goodGrapesImage,
        alt: 'Good Grapes wine discovery features',
      },
      {
        type: 'text',
        title: 'Brand experience',
        body:
          'Created a warm, sophisticated brand identity that balances the elegance of fine wine with the accessibility of a modern subscription service. The design emphasizes storytelling and education.',
      },
    ],
  },
  {
    slug: 'jumpcharge',
    title: 'JumpCharge',
    subtitle: 'Electric vehicle charging network and platform',
    meta: [
      { label: 'Client', value: 'JumpCharge' },
      { label: 'Focus', value: 'Product design + web' },
      { label: 'Deliverables', value: 'UX, UI, web' },
      { label: 'Status', value: 'Live' },
    ],
    intro:
      'A comprehensive EV charging platform that connects drivers with charging stations through an intuitive mobile and web experience.',
    blocks: [
      {
        type: 'image',
        src: jumpCharge1Image,
        alt: 'JumpCharge app interface',
      },
      {
        type: 'image',
        src: jumpCharge2Image,
        alt: 'JumpCharge station map',
      },
      {
        type: 'image',
        src: jumpCharge3Image,
        alt: 'JumpCharge charging interface',
      },
      {
        type: 'image',
        src: jumpCharge4Image,
        alt: 'JumpCharge payment flow',
      },
      {
        type: 'image',
        src: jumpCharge5Image,
        alt: 'JumpCharge dashboard',
      },
      {
        type: 'text',
        title: 'Charging made simple',
        body:
          'We designed a user-friendly platform that helps EV drivers find, reserve, and pay for charging stations with ease. The interface provides real-time availability and pricing information.',
      },
      {
        type: 'image',
        src: jumpChargeImage,
        alt: 'JumpCharge station locator',
      },
    ],
  },
];
